export const placeholderHomeTextArea = [
  {
    text: "Describe your wedding vision here. For example: A bride with an elegant floral updo, soft makeup, and diamond earrings, captured in romantic lighting.",
    language: "English",
  },
  {
    text: "Una novia radiante está sola con un vestido de novia espectacular, un vestido blanco fluido con mangas de encaje y una cola brillante, bajo luz suave.",
    language: "Spanish",
  },
  {
    text: "Eine strahlende Braut steht allein in einem atemberaubenden Hochzeitskleid, einem fließenden weißen Kleid mit Spitzärmeln und einer funkelnden Schleppe, in weichem Licht.",
    language: "German",
  },
  {
    text: "Une mariée éclatante se tient seule dans une robe de mariée époustouflante, une robe blanche fluide avec des manches en dentelle et une traîne étincelante, sous une lumière douce.",
    language: "French",
  },
];

export const AIWeddingPlannerPlaceholder = [
  {
    text: `Hi there! Planning your wedding? I’ve got you.\nAsk me anything — from setting a date to picking a venue or creating your timeline.\nTry: “Help me plan my wedding.”`,
    language: "English",
  },
  {
    text: "¡Hola! ¿Estás organizando tu boda? Estoy aquí para ayudarte.\nPregúntame lo que quieras: desde elegir la fecha hasta buscar un lugar o crear tu cronograma.\nPrueba con: Ayúdame a planear mi boda.",
    language: "Spanish",
  },
  {
    text: "Hallo! Planst du deine Hochzeit? Ich helfe dir gern.\nFrag mich alles — vom Datum festlegen über die Location bis hin zum Zeitplan.\nVersuch’s mit: Hilf mir, meine Hochzeit zu planen.",
    language: "German",
  },
  {
    text: "Bonjour! Vous organisez votre mariage ? Je suis là pour vous aider.\nPosez-moi toutes vos questions — fixer une date, choisir un lieu, créer votre planning.\nEssayez : Aide-moi à planifier mon mariage.",
    language: "French",
  },
];

export const AIWeddingPlannerPlaceholderResumeSession = [
  {
    text: `You’ve still got something in progress — want to continue?`,
    language: "English",
  },
  {
    text: "¡Hola! ¿Estás organizando tu boda? Estoy aquí para ayudarte.\nPregúntame lo que quieras: desde elegir la fecha hasta buscar un lugar o crear tu cronograma.\nPrueba con: Ayúdame a planear mi boda.",
    language: "Spanish",
  },
  {
    text: "Hallo! Planst du deine Hochzeit? Ich helfe dir gern.\nFrag mich alles — vom Datum festlegen über die Location bis hin zum Zeitplan.\nVersuch’s mit: Hilf mir, meine Hochzeit zu planen.",
    language: "German",
  },
  {
    text: "Bonjour! Vous organisez votre mariage ? Je suis là pour vous aider.\nPosez-moi toutes vos questions — fixer une date, choisir un lieu, créer votre planning.\nEssayez : Aide-moi à planifier mon mariage.",
    language: "French",
  },
];

export const AIWeddingPlannerPlaceholderContinuePlanning = [
  {
    text: `Hi there, good to see you again! Want to pick up right where we left off?`,
    language: "English",
  },
  {
    text: "¡Hola! ¿Estás organizando tu boda? Estoy aquí para ayudarte.\nPregúntame lo que quieras: desde elegir la fecha hasta buscar un lugar o crear tu cronograma.\nPrueba con: Ayúdame a planear mi boda.",
    language: "Spanish",
  },
  {
    text: "Hallo! Planst du deine Hochzeit? Ich helfe dir gern.\nFrag mich alles — vom Datum festlegen über die Location bis hin zum Zeitplan.\nVersuch’s mit: Hilf mir, meine Hochzeit zu planen.",
    language: "German",
  },
  {
    text: "Bonjour! Vous organisez votre mariage ? Je suis là pour vous aider.\nPosez-moi toutes vos questions — fixer une date, choisir un lieu, créer votre planning.\nEssayez : Aide-moi à planifier mon mariage.",
    language: "French",
  },
];

export const AIWeddingImageEditPlaceholder = [
  {
    text: "Upload your photo, then tell us what to change. Example: replace the flowers with pastel roses or remove people in the background.",
    language: "English",
  },
  {
    text: "Lade dein Foto hoch und sag uns, was geändert werden soll. Beispiel: die Blumen durch zartrosa Rosen ersetzen oder Personen im Hintergrund entfernen.",
    language: "German",
  },
  {
    text: "Téléversez votre photo puis dites‑nous la retouche souhaitée. Exemple : remplacer les fleurs par des roses pastel ou retirer les personnes à l’arrière‑plan.",
    language: "French",
  },
  {
    text: "Sube tu foto y cuéntanos qué cambiar. Ejemplo: reemplazar las flores por rosas pastel o eliminar a las personas del fondo.",
    language: "Spanish",
  },
];
